module.exports = __webpack_public_path__ + "img/two-col-grid-icon.b5ea0cbb.svg";